// extracted by mini-css-extract-plugin
export default {"type":"Hg8_a","characteristicValue":"vdukP","parameter":"aoJQe","sizeGroup":"YyIcu","defaultGroup":"Q34Az","icon":"bcy8Q"};